import React from "react";
import { Button } from "./ui/Button";
export function FinalCTA() {
  return <section className="w-full bg-[#142FA8] py-10 md:py-16 text-center px-4" data-id="element-122" data-mp="3ucdnw42x38nt">
      <div className="container mx-auto max-w-4xl" data-id="element-123" data-mp="3uei1xeuj5o1t">
        <h2 className="text-[26px] md:text-[36px] lg:text-[48px] font-[900] text-white tracking-[-1px] leading-[1.05] mb-4" data-id="element-124" data-mp="c70wp6v119mz">
          ¿LISTO PARA COMENZAR EN LA <span className="text-[#FFC900]" data-id="element-125" data-mp="87jrmejiieic">MECÁNICA INDUSTRIAL?</span>
        </h2>
        <p className="text-[14px] md:text-[16px] text-white/95 mb-6 md:mb-8 max-w-2xl mx-auto leading-[1.4]" data-id="element-126" data-mp="m340si9fvick">
          Accedé al material completo y empezá a estudiar a tu ritmo.
        </p>
        
        <div className="flex flex-col items-center max-w-md mx-auto" data-id="element-127" data-mp="vtyjxdre21ts">
          <Button size="xl" fullWidth className="mb-4" onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-128" data-mp="qwq59n5g8fxa">
            QUIERO ACCEDER AHORA <span className="ml-2 font-bold text-lg" data-id="element-129" data-mp="zwmx1xn4xuwk">→</span>
          </Button>
          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-[10px] md:text-xs font-[600] text-white/80" data-id="element-130" data-mp="zuij0mvivfik">
            <span data-id="element-131" data-mp="2h2y6t8cyu9sc">Pago seguro</span>
            <span className="hidden sm:inline" data-id="element-132" data-mp="2h3ztyb79amqf">•</span>
            <span data-id="element-133" data-mp="2m2b30jpq8t7l">Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-134" data-mp="2m19ilomtmud7">•</span>
            <span data-id="element-135" data-mp="2r2gofi5eljh8">Acceso de por vida</span>
          </div>
        </div>
      </div>
    </section>;
}